
import { AbstractQuery, AbstractQueryAction, ActionData } from '../http/data_query';
import { DocumentId } from './classes/document_id';

import { CreateBuilder } from './builder/create_builder';
import { UpdateBuilder } from './builder/update_builder';
import { SelectBuilder } from './builder/select_builder';
import { RawBuilder } from './builder/raw_builder';

export class QueryBuilder {

  constructor(private queryName: string) { }

  create(schemaName: string, document: any) {
    return new CreateBuilder(this.queryName, schemaName, document);
  }

  update(id: string, document: any) {
    return new UpdateBuilder(this.queryName, id, document);
  }

  delete() {
    throw Error('not implemented')
  }

  select() {
    return new SelectBuilder(this.queryName);
  }

  raw(actionName: string) {
    return new RawBuilder(this.queryName, actionName);
  }
}
